// extracted by mini-css-extract-plugin
export default {"container":"styles_container__TrN54","containerReversed":"styles_containerReversed__2eYPi"};